// Close Banner 

document.addEventListener('DOMContentLoaded', () => {
    const closeBanner = document.querySelector('.hero-contact__banner-close');

    if (closeBanner) {
        closeBanner.addEventListener('click', function () {
            this.closest('.hero-contact__banner').style.display = 'none';
            if (window.innerWidth < 768) {
                this.closest('.hero-contact').classList.remove('hero-contact--has-banner');
            }
        });
    }
});